import { render } from "./StatsTransactions.vue?vue&type=template&id=8ce04a90"
import script from "./StatsTransactions.vue?vue&type=script&lang=js"
export * from "./StatsTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__